export const pixelToRem = (pixel: number) => `${pixel / 16}rem`;
